/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionoriginallanguage3Inputs */

const en_eventdescriptionoriginallanguage3 = /** @type {(inputs: Eventdescriptionoriginallanguage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original language`)
};

const de_eventdescriptionoriginallanguage3 = /** @type {(inputs: Eventdescriptionoriginallanguage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalsprache`)
};

/**
* | output |
* | --- |
* | "Original language" |
*
* @param {Eventdescriptionoriginallanguage3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionoriginallanguage3 = /** @type {((inputs?: Eventdescriptionoriginallanguage3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionoriginallanguage3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionoriginallanguage3(inputs)
	return de_eventdescriptionoriginallanguage3(inputs)
});
export { eventdescriptionoriginallanguage3 as "eventDescriptionOriginalLanguage" }